import { Col } from 'react-bootstrap';
import { SectionHeadingMed, HeadingDesc } from '../../../Components/Headings';
import { SimpleButton } from '../../../Components/button';
import CallToAction from '../../../Components/callToAction/CallToAction';
import img1 from '../../../assets/images/png/approveddoc.png';
import './recomendedDoc.css';

function RecomendedDoc() {
  return (
    <CallToAction
      leftContent={<LeftContent />}
      rightContent={<RightConten />}
    />
  );
}

function RightConten() {
  return (
    <Col md={5} className="order-lg-2 order-1">
      <div>
        <img src={img1} alt="bloodpressure" />
      </div>
    </Col>
  );
}

function LeftContent() {
  return (
    <Col md={7} className="order-lg-1 order-2">
      <div>
        <SectionHeadingMed
          text="ڈاکٹروں کے ذریعہ منظور شدہ اور تجویز کردہ۔
"
        />
        <HeadingDesc
          text="ہماری HealthCheck ٹیکنالوجی عالمی کلینیکل ٹرائلز کی ایک سیریز سے گزری ہے اور فی الحال FDA کی منظوری کے اعلی درجے کے مراحل میں ہے۔
"
        />
        <HeadingDesc
          text="ہم نے اسے تیار کیا ہے تاکہ ہر جگہ کے خاندان صحت مند اور بہتر طور پر باخبر رہ سکیں - رات ہو یا دن!
"
        />
        <SimpleButton
          text="اپنے وائٹلز کو ابھی اسکین کریں۔
"
          bgColor="#EF6286"
        />
      </div>
    </Col>
  );
}

export default RecomendedDoc;
